module.exports = __webpack_public_path__ + "static/media/welcome-slider-1-en-md.8b7c5011.png";